import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useToastStore } from '../shared/stores/toastStore';

const getTopLevelSegment = (pathname: string) => pathname.split('/')[1];

export const useClearToasts = () => {
  const location = useLocation();
  const { toasts: storeToasts, resetToasts: resetStoreToasts } = useToastStore();
  const prevSegmentRef = useRef(getTopLevelSegment(location.pathname));

  useEffect(() => {
    const currentSegment = getTopLevelSegment(location.pathname);

    if (currentSegment !== prevSegmentRef.current) {
      prevSegmentRef.current = currentSegment;
      storeToasts.length && resetStoreToasts();
    }
  }, [location.pathname]);
};
